import { ThemeProvider as ThemeProvider$1 } from '@mui/material/styles';
import { createSitooTheme } from '../../theme/index.js';
import { jsx } from 'react/jsx-runtime';

const ThemeProvider = _ref => {
  let {
    children,
    mode
  } = _ref;
  const theme = createSitooTheme(mode);
  return /*#__PURE__*/jsx(ThemeProvider$1, {
    theme: theme,
    children: children
  });
};

export { ThemeProvider };
